<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="`Create Delivery for Sales Order # ${baseView.id}`"
        :secondaryLabel="customerName"
        v-if="loaded"
      />
    </template>

    <div class="despatch-order-v2 css-v2 transaction-screen">
      <gc-header-form
        :headerOptions="getHeaderScreenJson"
        :data="loaded ? model : {}"
        :saveTransaction="saveTransaction"
        :backButtonRoute="backButtonRoute"
        ref="gc-header-form-component"
        :getHeaderToolbar="getHeaderToolbar"
        :setLoading="showLoading"
        v-show="!gridExpand"
      ></gc-header-form>
      <div class="data-grid-details">
        <dx-data-grid
          :data-source="dataGridLocalItemDataSource"
          :columns="getProductEntryColumns"
          :height="getGridHeight"
          :column-chooser="{ enabled: false }"
          :ref="'dx-data-grid-comp'"
          :key-expr="'ID'"
          :repaint-changes-only="true"
          :show-borders="true"
          :two-way-binding-enabled="false"
          :focusedRowEnabled="true"
          @toolbar-preparing="onToolbarPreparing($event)"
          :onSelectionChanged="checkBoxValueChange"
        >
          <template #product-cell-template="{ data }">
            <GcRecord
              :data="data"
              :primary="[{ dataField: 'ItemDescription' }]"
              :secondary="[{ dataField: 'ItemCode' }]"
              :showImage="true"
            />
          </template>

          <DxEditing
            :allow-updating="baseView.mode != 'review'"
            :allow-deleting="false"
            mode="cell"
            :new-row-position="'last'"
          />

          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="true"
          />

          <DxPaging :page-size="200" :enabled="true" />

          <template #menu-cell-template="{ data }">
            <DxDropDownButton
              :items="getEllipsisMenuItems(data)"
              keyExpr="menuText"
              displayExpr="menuText"
              :drop-down-options="{ width: 150 }"
              class="gc-dropdown-icon-button"
              :id="data.data.ID"
              :icon="'overflow'"
              styling-mode="text"
              :show-arrow-icon="false"
              :onItemClick="onSoDetailsLineContextMenuItemClick"
              :disabled="!data.data.ItemCode"
            />
          </template>

          <DxSelection
            :select-all-mode="'allPages'"
            :show-check-boxes-mode="'always'"
            mode="multiple"
            selectionChange
          />
        </dx-data-grid>
      </div>

      <GcFooter v-if="showFooter">
        <template #leftContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerLeftItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>

            <label
              v-if="item.fieldType == 'custome-string'"
              class="gc-footer-value"
              >{{ item.value }}</label
            >
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
              v-else
            />
          </div>
        </template>
      </GcFooter>
    </div>

    <GcPopUpAddSalesOrderItem
      v-if="addSalesOrderItem && addSalesOrderItem.visible"
      :setVisible="addSalesOrderItem.visible"
      :callBack="addSalesOrderItem.popUpCallBack"
      :addSalesOrderItemData="addSalesOrderItem.addSalesOrderItemData"
      :formContentReady="addSalesOrderItem.formContentReady"
      :baseView="baseView"
      :setLoading="showLoading"
    ></GcPopUpAddSalesOrderItem>

    <GcPopUpAlmondcoDespatchData
      v-if="almondcoDespatchData"
      :setVisible="almondcoDespatchData.visible"
      :almondcoDespatchData="almondcoDespatchData"
      :setLoading="showLoading"
      :showValidationSummary="showValidationSummary"
    />

    <gc-item-price-update
      v-if="itemPriceUpdate && itemPriceUpdate.visible"
      :setVisible="itemPriceUpdate.visible"
      :callBack="itemPriceUpdate.popUpCallBack"
      :itemPriceUpdateData="itemPriceUpdate.itemPriceUpdateData"
      :branchCode="itemPriceUpdate.model.BranchCode"
      :baseView="baseView"
      :setLoading="showLoading"
    ></gc-item-price-update>

    <GcPopUpEditProductItem
      v-if="editProductItem && editProductItem.visible"
      :setVisible="editProductItem.visible"
      :callBack="editProductItem.popUpCallBack"
      :editProductItemData="editProductItem.editProductItemData"
      :formContentReady="editProductItem.formContentReady"
      :baseView="baseView"
      :setLoading="showLoading"
    ></GcPopUpEditProductItem>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { getGlobalField } from "../../_store/helpers";
import { mapGetters } from "vuex";
import SalesFormulas from "../../_helpers/formulas/sales-formulas";
import ArrayStore from "devextreme/data/array_store";
import { DespatchOrderService } from "../../_services/api/sales/despatch-order.service";
import { CacheService } from "../../_services/cache/cache-service";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { FeatureStorage } from "../../_services/storage";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {},
  data() {
    return {
      loaded: false,
      processInvoiceSettingValue: undefined,
      model: {
        Status: "D",
        CustomStatus: "Credit Hold",
        ProcessInvoice: true,
      },
      dataGridLocalItemDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      showFooter: true,
      addSalesOrderItem: {},
      almondcoDespatchData: undefined,
      editProductItem: undefined,
      itemPriceUpdate: undefined,
      footerItems: [],
      customerName: "",
      ellipsisMenuItems: [],
      selectedRows: [],
    };
  },

  async created() {
    this.getProcessInvoiceSetting();
  },
  async mounted() {
    this.showLoading(true);
    this.initialized();
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ headerFormHeight: "ui/getHeaderFormHeight" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({
      getValidationSummaryVisible: "ui/getValidationSummaryVisible",
    }),
    getHeaderToolbar() {
      return {
        headerToolbar: {
          audit: this.baseView.mode == "review",
          status: false,
          notes: true,
          notesDropDownOptions: { width: 170 },
          save: true,
          saveCallback: this.saveDespatchOrder,
          commentsTitle: "Sales Order Comments",
          toolbarAfterFormItems: [
            {
              screenField: "Inactive",
              dataField: "ProcessInvoice",
              editorType: "dxSwitch",
              label: {
                text: "Process Invoice",
              },
              visible:
                this.processInvoiceSettingValue == "D" ||
                this.processInvoiceSettingValue == "U"
                  ? false
                  : true,
            },
          ],

          customButtons: [
            {
              label: "save",
              icon: "..",
              type: " ",
              click: "",
              menu: [
                {
                  label: "Credit Comments",
                  clickAction: "",
                },
              ],
            },
          ],
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {},
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {},
                },
              ],
            },
          ],
          orderComments: {
            dataField: "SalesOrderType.Code",
            endpoint: "SalesOrderType",
            toMatch: [
              "UserComment1",
              "UserComment2",
              "UserComment3",
              "UserComment4",
              "UserComment5",
              "UserComment6",
              "UserComment7",
              "UserComment8",
              "UserComment9",
              "UserComment10",
              "UserComment11",
              "UserComment12",
              "UserComment13",
              "UserComment14",
              "UserComment15",
              "UserComment16",
              "UserComment17",
              "UserComment18",
              "UserComment19",
              "UserComment20",
            ],
          },
          commentItems: [
            {
              itemType: "group",
              caption: "",
              items: [],
            },
          ],
        },
      };
    },

    getGridHeight() {
      if (this.headerFormHeight)
        return (
          this.gridHeight - (this.gridExpand ? 6 : this.headerFormHeight) - 65
        );
      else return this.gridHeight - 65;
    },
    backButtonRoute() {
      return "/despatch-order";
    },
    getScreenJson() {
      var screenJson = {
        title: "Screen Name",
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerFormVisible: true,

        deliveryAddressItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "DeliveryAddressCompanyName",
                editorType: "dxTextBox",
                label: {
                  text: "Name",
                },
                editorOptions: {
                  maxLength: "100",
                  readOnly: true,
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressStreetLine1",
                dataField: "DeliveryAddressStreetLine1",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressStreetLine2",
                dataField: "DeliveryAddressStreetLine2",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressSuburb",
                dataField: "DeliveryAddressSuburb",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressState",
                dataField: "DeliveryAddressState",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressPostcode",
                dataField: "DeliveryAddressPostcode",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressCountry",
                dataField: "DeliveryAddressCountry",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
            ],
          },
        ],
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "DateIn",
                    editorOptions: {
                      value:
                        this.baseView.mode != "review" ? new Date() : undefined,
                    },
                    required: this.baseView.mode != "review",
                  },
                  {
                    screenField: "RequiredDate",
                    dataField: "RequiredByDate",
                    allowUpdate: false,
                    label: {
                      text: "Reqd Date",
                    },
                  },
                  {
                    screenField: "ShipDate",
                    allowUpdate: false,
                  },
                  {
                    screenField: "CustPO",
                    dataField: "OrderNo",
                    allowUpdate: false,
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  // {
                  //   screenField: "DeliverTo",
                  //   dataField: "DeliveryAddressCompanyName",

                  //   onItemClick: this.setDeliverTo,
                  //   ref: "DeliveryAddressCompanyName",
                  //   acceptCustomValue: true,
                  //   onCustomItemCreating: (data) => {
                  //     if (!data.text) {
                  //       return;
                  //     } else {
                  //       this.deliverToCustomItem(data);
                  //     }
                  //   },
                  // },
                  // {
                  //   screenField: "DeliveryCompanyView",
                  //   editAddress: this.baseView.mode != "review" ? true : false,
                  // },

                  {
                    itemType: "group",
                    caption: "",
                    cssClass: "deliver-to",
                    items: [
                      {
                        screenField: "DeliverTo",
                        dataField: "DeliveryAddressCompanyName",
                        ref: "DeliveryAddressCompanyName",
                        required: true,
                        editorOptions: {
                          onItemClick: this.setDeliverTo,
                          // allowUpdate: true,
                        },
                        // dataSourceConfig: {
                        //   // ingnore: true,
                        //   data: deliveryAddressDataSourceItems,
                        // },
                        visible: this.baseView.mode != "review",
                        acceptCustomValue: true,
                        onCustomItemCreating: (data) => {
                          if (!data.text) {
                            return;
                          } else {
                            this.deliverToCustomItem(data);
                          }
                        },
                      },
                      {
                        screenField:
                          this.baseView.mode != "review"
                            ? "DeliverTo"
                            : undefined,
                        dataField: "DeliveryAddressCompanyName",
                        ref: "DeliveryAddressCompanyName",
                        label: {
                          text: "Deliver To",
                        },
                        required: true,
                        visible: this.baseView.mode == "review",
                      },
                      {
                        screenField: "DeliveryCompanyView",
                        editAddress:
                          this.baseView.mode != "review" ? true : false,
                      },
                    ],
                  },
                  {
                    screenField: "ConNote",
                    dataField: "ConsignmentNo",
                  },
                  {
                    screenField: "Currency",
                    dataField: "Currency",
                    allowUpdate: false,
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    label: {
                      text: "Branch",
                    },
                    dataField: "Branch.Description",
                    allowUpdate: false,
                  },
                  {
                    label: {
                      text: "Division",
                    },
                    dataField: "Division.Description",
                    allowUpdate: false,
                  },
                  {
                    screenField: "OrderType",
                    dataField: "SalesOrderType.Description",
                    allowUpdate: false,
                  },
                  {
                    screenField: "SalesRep",
                    dataField: "SalesRepFullName",
                    allowUpdate: false,
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    getProductEntryColumns() {
      return [
        {
          caption: "Product / Account",
          dataField: "ItemCode",
          cellTemplate: "product-cell-template",
          allowEditing: false,
        },
        {
          caption: "Sales UM",
          dataField: "SalesUM",
          allowEditing: false,
          width: 80,
          minWidth: 80,
        },
        {
          caption: "Price",
          dataField: "SalesUMNetFXPrice",
          format: "$ ##,###,###,###,##0.00;($ ##,###,###,###,##0.00)",
          allowEditing: false,
          width: 120,
          minWidth: 120,
        },
        {
          caption: "GP %",
          dataField: "SalesUMStandardCost",
          format: "##,###,###,###,##0.00 '%';(##,###,###,###,##0.00 '%')",
          calculateCellValue: (rowData) => {
            return SalesFormulas.calculateGrossProfitPcnt(
              rowData.SalesUMStandardCost,
              rowData.SalesUMNetPrice
            );
          },
          allowEditing: false,
          width: 120,
          minWidth: 120,
        },
        {
          caption: "Outstanding",
          dataField: "SalesUMBackorderQty",
          format: "##,###,###,###,##0.00",
          allowEditing: false,
          width: 120,
          minWidth: 120,
        },
        {
          caption: "Picked",
          dataField: "SalesUMPickedQty",
          format: "##,###,###,###,##0.00",
          allowEditing: true,
          showEditorAlways: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.00",
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
          setCellValue: (newData, value, currentRowData) => {
            newData.SalesUMPickedQty = value;
            newData["StockUMQuantityToPick"] =
              newData["SalesUMPickedQty"] * currentRowData["SalesUMConversion"];
            newData.ID = currentRowData.ID;
            let backOrderValue = currentRowData.SalesUMBackorderQty;

            var dataGrid = this.$refs["dx-data-grid-comp"].instance;

            if (value >= backOrderValue) {
              newData.Completed = true;
            }
            if (newData.SalesUMPickedQty > 0) {
              dataGrid.selectRows([currentRowData.ID], true);
            } else {
              newData.Completed = false;
            }
            if (newData.SalesUMPickedQty < currentRowData.SalesUMBackorderQty) {
              newData.Completed = false;
            }

            this.updateCellValue(currentRowData.ID, "Completed", newData);
            return newData;
          },
          width: 120,
          minWidth: 120,
        },
        {
          caption: "Stock UM",
          dataField: "UnitOfMeasureCode",
          allowEditing: false,
          width: 80,
          minWidth: 80,
        },
        {
          caption: "Stock UM Picked",
          dataField: "StockUMQuantityToPick",
          format: "##,###,###,###,##0.00",
          allowEditing: false,
          showEditorAlways: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.00",
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
          setCellValue: (newData, value) => {
            newData.StockUMQuantityToPick = value;
          },
          width: 120,
          minWidth: 120,
        },
        {
          caption: "Complete",
          dataType: "boolean",
          dataField: "Completed",
          width: 80,
          minWidth: 80,
          fixedPosition: "right",
        },
        {
          caption: "",
          dataField: "",
          width: 40,
          minWidth: 30,
          maxWidth: 80,
          allowEditing: false,
          cellTemplate: "menu-cell-template",
          alignment: "left",
          cssClass: "more-menu",
          fixedPosition: "right",
          fixed: true,
          allowFixing: true,
          allowReordering: false,
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
          allowGrouping: false,
        },
      ];
    },
    // Footer
    getFooterItems() {
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SalesUMPickedQty",
          label: "Total Picked",
          location: "left",
          value: 0,
          fieldType: "custome-string",
          customCalc: (headerData, gridItems) => {
            let totalPickedQty = 0;
            let totalBackOrderQty = 0;
            gridItems.forEach((el) => {
              totalPickedQty += Number(el.SalesUMPickedQty);
              totalBackOrderQty += Number(el.SalesUMBackorderQty);
            });

            return (
              totalPickedQty.toFixed(2) + " / " + totalBackOrderQty.toFixed(2)
            );
          },
        },
      ];
    },

    footerLeftItems() {
      var leftItems = this.footerItems.filter((x) => x.location == "left");

      return leftItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };
          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;
          if (c.fieldType != undefined) globalField.fieldType = c.fieldType;
          if (c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          // if(c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
  },
  methods: {
    refreshDataGird() {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh(true);
    },
    checkBoxValueChange(event) {
      event.currentSelectedRowKeys.forEach(async (key) => {
        let rowData = await this.dataGridLocalItemDataSource.byKey(key);
        if (
          rowData.IsBatchProduct.toLowerCase() == "no" &&
          rowData.SalesUMPickedQty == 0
        ) {
          rowData.SalesUMPickedQty = rowData.SalesUMBackorderQty;
          rowData.StockUMQuantityToPick = rowData.StockUMBackorderQty;
          rowData.Completed = true;
          this.updateCellValue(rowData.ID, "Completed", rowData);
        }
      });
      event.currentDeselectedRowKeys.forEach(async (key) => {
        let rowData = await this.dataGridLocalItemDataSource.byKey(key);
        if (rowData.IsBatchProduct.toLowerCase() == "no") {
          rowData.SalesUMPickedQty = 0;
          rowData.StockUMQuantityToPick = 0;
          rowData.Completed = false;
          this.updateCellValue(rowData.ID, "Completed", rowData);
        }
      });
      this.refreshDataGird();
    },
    getEllipsisMenuItems(data) {
      return [
        {
          menuText: "Item Price Update",
          data: data,
        },
        {
          menuText: "Despatch Data",
          data: data,
          visible: FeatureStorage.checkPermission(
            "AlmondcoDespatchData",
            "create"
          ),
        },
        {
          menuText: "Edit Item",
          data: data,
          visible: FeatureStorage.checkPermission(
            "DespatchOrderDetailEditPrice",
            "edit"
          ),
        },
      ];
    },
    showValidationSummary(val) {
      if (val.length > 0) {
        this.displayValidationSummary(val);
      }
    },
    async getDespatchOrderDetails(updated, updatedItemId, updatedPriceItem) {
      await DespatchOrderService.getDespatchOrderCode(this.baseView.id).then(
        (res) => {
          this.model = res.data.value[0];
          this.model.SalesRepFullName =
            this.model.SalesRepresentative.FirstName +
            " " +
            this.model.SalesRepresentative.Surname;
          this.model.ProcessInvoice = true;
          this.customerName = this.model.Customer.Name;
        }
      );

      await this.setOrderComments(this.model.SalesOrderTypeCode);
      await DespatchOrderService.getDespatchOrderDetailsByCode(
        this.baseView.id
      ).then((res) => {
        res.data.value.forEach((element) => {
          element.ID = element["LineNo"];
          if (element.ItemType == "G") {
            // GL Item
            element["CheckInclude"] = true;
            element["Product"] = { UnitOfMeasureCode: element["SalesUM"] };
            element["StockUM"] = element["UnitOfMeasureCode"];
            element["SalesUMPickedQty"] = element["SalesUMBackorderQty"];
            element["StockUMQuantityToPick"] = element["SalesUMPickedQty"];
            element["Completed"] = true;
          } else {
            // ItemType == 'S' (Stock Item)
            element["StockUM"] = element["UnitOfMeasureCode"];
            if (element.IsBatchProduct == "No") {
              element.CheckInclude = true;
              element["SalesUMPickedQty"] = element["SalesUMBackorderQty"];
              element["Completed"] = true;
            } else {
              element["SalesUMPickedQty"] = 0;
              element["ChildDataSource"] = [];
              element["Completed"] = false;
              if (element["IsBatchProduct"] == "Auto") {
                element["IsVisibleBatchData"] = true;
              }
              if (element["IsBatchProduct"] != "No") {
                DespatchOrderService.getPickingSlipProductBatch(
                  `ItemCode eq '${element["ItemCode"]}' and SalesOrderLineNo eq ${element["LineNo"]} and SalesOrderCode eq ${element["SalesOrderCode"]}`
                )
                  .then((response) => {
                    var totalQTY = 0;
                    element["ChildDataSource"] = response.data.value;
                    element["ChildDataSource"].forEach((batch) => {
                      batch.Qty = batch.AllocatedQty;
                      totalQTY = totalQTY + batch.AllocatedQty;
                    });
                    element["SalesUMPickedQty"] = totalQTY;

                    if (totalQTY == element["SalesUMBackorderQty"])
                      element["Completed"] = true;
                    else element["Completed"] = false;

                    element["ChildDataSource_COPY"] =
                      element["ChildDataSource"].slice();

                    if (element["ChildDataSource"].length == 0) {
                      element["ChildDataSource"].push({
                        AllocatedQty: 0,
                        AvailableQty: 0,
                        BatchNo: undefined,
                        BranchCode: undefined,
                        CompanyCode: undefined,
                        ItemCode: undefined,
                        OnHand: undefined,
                        Qty: undefined,
                        SalesOrderCode: undefined,
                        SalesOrderLineNo: undefined,
                        SupplierBatchNo: undefined,
                        SupplierCode: undefined,
                        SupplierName: undefined,
                        UseByDate: undefined,
                      });
                    }
                  })
                  .then(() => {
                    if (element["ChildDataSource"].length > 0) {
                      var Totalpicked = 0;
                      element["ChildDataSource"].forEach((row) => {
                        if (row.Qty > 0) {
                          Totalpicked = Totalpicked + row.Qty;
                          element.CheckInclude = true;
                        }
                      });
                      element.totalPickedQty = Totalpicked;
                      element.StockUMQuantityToPick =
                        Totalpicked * element.SalesUMConversion;
                      if (Totalpicked == element["SalesUMBackorderQty"]) {
                        element["Completed"] = true;
                      }
                      if (Totalpicked < element["SalesUMBackorderQty"]) {
                        element["Completed"] = false;
                      }
                    }
                  });
              } else {
                element["Completed"] = false;
              }
            }
            element["StockUMQuantityToPick"] =
              element["SalesUMPickedQty"] * element["SalesUMConversion"];
          }
          if (updatedItemId == element.ID) {
            this.dataGridLocalItemDataSource.push([
              { type: "update", data: element, key: element.ID },
            ]);
          } else if (updatedPriceItem == element.ItemCode) {
            this.dataGridLocalItemDataSource.push([
              { type: "update", data: element, key: element.ID },
            ]);
          } else {
            this.dataGridLocalItemDataSource.push([
              { type: "insert", data: element },
            ]);
          }
        });
      });

      if (updated) {
        setTimeout(() => {
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;
          dataGrid.refresh(true);
        }, 500);
      }
    },
    enableAddSalesOrderItem() {
      this.addSalesOrderItem = {
        visible: true,
        addSalesOrderItemData: this.model,
        popUpCallBack: this.popUpCallBack,
      };
    },
    enableItemPriceUpdate(data) {
      this.itemPriceUpdate = {
        visible: true,
        popUpCallBack: this.itemPriceUpdateCallback,
        itemPriceUpdateData: data,
        model: this.model,
      };
    },
    async enableAlmondcoDespatchData(data) {
      // this.setLoading = true;
      this.$store.dispatch("dataContext/setAllowDataContext", false);

      data.StockUMSuppliedQty = data.StockUMQuantityToPick;

      this.almondcoDespatchData = {
        // localItems: res.data.value,
        visible: true,
        popUpCallBack: this.popUpCallBack,
        data: data,
        model: this.model,
      };
    },
    enableEditProductItem(data) {
      data.BranchCode = this.model.BranchCode;
      this.editProductItem = {
        visible: true,
        editProductItemData: data,
        popUpCallBack: this.editPopUpCallBack,
        model: this.model,
      };
    },
    async itemPriceUpdateCallback(updated, returnValue, element) {
      this.setLoading = false;
      this.$store.dispatch("dataContext/setAllowDataContext", true);
      if (this.itemPriceUpdate) this.itemPriceUpdate.visible = false;
      if (updated) {
        if (element) {
          await this.getDespatchOrderDetails(true, null, element.ItemCode);
        }
      }
    },
    async popUpCallBack(updated) {
      this.setLoading = false;
      this.$store.dispatch("dataContext/setAllowDataContext", true);
      this.almondcoDespatchData = undefined;
      this.addSalesOrderItem = undefined;
      if (updated) {
        await this.getDespatchOrderDetails(true);
        this.updateLocalDataSet(null, null);
      }
    },
    async editPopUpCallBack(newItem) {
      this.setLoading = false;
      this.editProductItem = undefined;
      if (newItem) {
        await this.getDespatchOrderDetails(true, newItem.ID);
      }
    },
    async saveDespatchOrder(data, gridItems) {
      this.validationSummary = [];
      let payload = {
        DateIn: new Date(data.DateIn).toSaveDate(),
        ProcessInvoice: data.ProcessInvoice ? "Y" : "N",
        PartDeliver: data.PartDeliver ? "Y" : "N",
        BackOrder: data.BackOrder ? "Y" : "N",
        DeliveryAddressCompanyName: data.DeliveryAddressCompanyName,
        DeliveryAddressCountry: data.DeliveryAddressCountry,
        DeliveryAddressPostcode: data.DeliveryAddressPostcode,
        DeliveryAddressState: data.DeliveryAddressState,
        DeliveryAddressStreetLine1: data.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: data.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: data.DeliveryAddressSuburb,
        ConsignmentNo: data.ConsignmentNo,
        SalesOrderCode: data.SalesOrderCode,
        UserComment1: data.UserComment1,
        UserComment10: data.UserComment10,
        UserComment11: data.UserComment11,
        UserComment12: data.UserComment12,
        UserComment13: data.UserComment13,
        UserComment14: data.UserComment14,
        UserComment15: data.UserComment15,
        UserComment16: data.UserComment16,
        UserComment17: data.UserComment17,
        UserComment18: data.UserComment18,
        UserComment19: data.UserComment19,
        UserComment2: data.UserComment2,
        UserComment20: data.UserComment20,
        UserComment3: data.UserComment3,
        UserComment4: data.UserComment4,
        UserComment5: data.UserComment5,
        UserComment6: data.UserComment6,
        UserComment7: data.UserComment7,
        UserComment8: data.UserComment8,
        UserComment9: data.UserComment9,
        PickingSlipDetails: [],
        ScreenName: "Order Despatch Console",
      };

      gridItems.forEach((el) => {
        let obj = {
          BatchStockTolerance: el.BatchStockTolerance, //
          Completed: el.Completed ? "Y" : "N", //
          ItemCode: el.ItemCode,
          LineNo: el.LineNo,
          SalesUM: el.SalesUM,
          SalesUMConversion: el.SalesUMConversion,
          SalesUMInvoiceConversion: el.SalesUMConversion,
          SalesUMIsVariable: el.SalesUMIsVariable,
          SalesUMQuantityToPick: el.SalesUMPickedQty, //
          StockUM: el.UnitOfMeasureCode,
          StockUMQuantityToPick: el.StockUMQuantityToPick,

          StockUMSuppliedQty: el.StockUMQuantityToPick,
          PickingSlipProductBatches: [],
          AlmondcoWriteDespatchData: el.AlmondcoWriteDespatchData
            ? el.AlmondcoWriteDespatchData
            : undefined,
        };
        payload.PickingSlipDetails.push(obj);
      });

      if (payload.PickingSlipDetails.length == 0) {
        this.$alert("No line item has been selected", "Validation Errors");
      } else {
        this.setLoading = true;
        await DespatchOrderService.saveDespatchOrder(payload)
          .then((res) => {
            this.setLoading = false;

            this.$notify(
              `Sales Order ${res.data.SalesOrderCode} despatched successfully`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/despatch-order`,
            });
          })
          .catch((error) => {
            this.serverError = {
              err: error,
              msg: "Despatch save failed",
              time: new Date().getTime(),
            };

            this.setLoading = false;
          });
      }
    },
    async getProcessInvoiceSetting() {
      var processInvoiceSetting = CacheService.getCache(
        "ProcessInvoiceToggle_Setting"
      );

      if (!processInvoiceSetting)
        await SettingsService.getBySettingName("ProcessInvoiceToggle").then(
          (res) => {
            if (res.data.value.length > 0) {
              this.processInvoiceSettingValue = res.data.value[0].SettingValue;

              CacheService.saveCache(
                "ProcessInvoiceToggle_Setting",
                res.data.value[0],
                15
              );
            }
          }
        );
      else this.processInvoiceSettingValue = processInvoiceSetting.SettingValue;
    },
    onSoDetailsLineContextMenuItemClick(e) {
      switch (e.itemData.menuText) {
        case "Item Price Update":
          this.enableItemPriceUpdate(e.itemData.data.data);
          break;
        case "Despatch Data":
          this.enableAlmondcoDespatchData(this.model);
          break;
        case "Edit Item":
          this.enableEditProductItem(e.itemData.data.data);
          break;
        default:
          break;
      }
    },
    updateCellValue(key, dataField, data) {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      var rowIndex = dataGrid.getRowIndexByKey(key);
      dataGrid.cellValue(rowIndex, dataField, data[dataField]);
      this.updateLocalDataSet("update", data);
    },
    async updateLocalDataSet(type, dataObj) {
      if (type == "insert") {
        if (
          this.dataGridLocalItemDataSource._array.length != 0 &&
          this.dataGridLocalItemDataSource._array[
            this.dataGridLocalItemDataSource._array.length - 1
          ].Code
        )
          this.dataGridLocalItemDataSource.push([
            { type: "insert", data: dataObj },
          ]);
        else if (this.dataGridLocalItemDataSource._array.length == 0)
          this.dataGridLocalItemDataSource.push([
            { type: "insert", data: dataObj },
          ]);
      } else if (type == "update")
        this.dataGridLocalItemDataSource.push([
          {
            type: "update",
            key: dataObj.ID,
            data: dataObj,
          },
        ]);

      this.setFooterItems(this.dataGridLocalItemDataSource._array);
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh(true);
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },

    // Save Transaction
    async saveTransaction(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.saveDespatchOrder(
          this.model,
          this.$refs["dx-data-grid-comp"].instance.getSelectedRowsData()
        );
      }
    },

    // Start - Details Data Grid Functions

    onToolbarPreparing(e) {
      e.toolbarOptions.items.push(
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            icon: this.gridExpand ? "collapse" : "expand",
            onClick: this.expandGrid,
          },
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: 'plus',
            text: "Add Item",
            elementAttr: {
              class: "cx-color-button",
            },
            onClick: () => {
              this.enableAddSalesOrderItem();
            },
            visible: this.baseView.mode != "review",
          },
        }
      );
    },
    expandGrid() {
      this.$store.dispatch("ui/setGridExpand", !this.gridExpand);
      setTimeout(() => {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

        dataGrid.beginUpdate();
        dataGrid.updateDimensions();
        dataGrid.endUpdate();

        dataGrid.refresh(true);
      }, 500);
    },
    // End - Details Data Grid Functions

    // Start - Header Form Functions

    // End - Header Form Functions

    // Start - On initialized Functions
    async initialized() {
      await this.getDespatchOrderDetails(true, null, null);
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh(true);
      this.setFooterItems(this.dataGridLocalItemDataSource._array);

      this.loaded = true;
      this.showLoading(false);
    },
    // End - On initialized Functions

    // Footer

    async setFooterItems(gridItems) {
      this.showFooter = false;
      await this.getFooterItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = this.updateValue(x.dataField, gridItems);
          if (x.customCalc) x.value = x.customCalc(this.model, gridItems);
        });
      this.footerItems = this.getFooterItems;
      this.showFooter = true;
    },
    updateValue(dataField, items) {
      let result = 0;
      if (items.length > 0)
        items.forEach((x) => {
          if (x.CheckInclude || this.baseView.mode == "review")
            result += parseFloat(x[dataField]).roundNumber(4);
          else if (x.CheckInclude == undefined)
            result += parseFloat(x[dataField]).roundNumber(4);
        });

      return result;
    },
  },
  watch: {
    validationSummary: {
      handler(val) {
        if (val.length > 0) {
          this.displayValidationSummary(val);
        }
      },
      deep: true,
    },
    async getValidationSummaryVisible(val) {
      if (!val && this.validationLineData == "Customer") {
        if (this.gridExpand) await this.expandGrid();
        this.validationLineData = undefined;
        var headerToolBarForm =
          this.$refs["gc-header-form-component"].$refs["gc-form-header-toolbar"]
            .$refs["toolbar-form"].$refs["gc-form-comp"].instance;
        if (headerToolBarForm) {
          headerToolBarForm.getEditor("CustomerCode").focus();
          var cusDropdown = headerToolBarForm
            .getEditor("CustomerCode")
            .instance();
          cusDropdown.open();
        }
      } else if (!val && this.validationLineData) {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        var rowIndex = dataGrid.getRowIndexByKey(this.validationDataField);
        var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
        dataGrid.focus(cellElement);
        dataGrid.editCell(rowIndex, "ProductCode");

        var index = this.dataGridLocalItemDataSource._array.findIndex(
          (x) => x.ID == this.validationDataField
        );
        if (index != -1) {
          if (this.dataGridLocalItemDataSource._array[index].validCode) {
            dataGrid.cellValue(
              rowIndex,
              "ProductCode",
              this.dataGridLocalItemDataSource._array[index].validCode
            );
          }
        }

        this.validationLineData = undefined;
        this.validationDataField = undefined;
      }
    },
  },
};
</script>

<style lang="scss">
.despatch-order-v2 {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle !important;
  }
  .dx-datagrid {
    .dx-datagrid-header-panel {
      .dx-toolbar {
        .dx-toolbar-items-container {
          .dx-button.dx-button-has-text {
            width: 70px;
          }
        }
      }
    }
  }

  .data-grid-details{
    padding-bottom: 0px !important;
  }

  .gc-grid-footer{
    border-radius: 0 0 3px 3px;
    // padding: 5px 0 5px 0;
    .gc-footer-label , .gc-footer-value{
      font-size: 12px;
    }
  }

  .gc-grid-footer-css-v2{
    // padding: 0 10px 10px;
  }
}
</style>
